import { render, staticRenderFns } from "./CompositeProduct.vue?vue&type=template&id=1858d85a&"
import script from "./CompositeProduct.vue?vue&type=script&lang=js&"
export * from "./CompositeProduct.vue?vue&type=script&lang=js&"
import style0 from "./CompositeProduct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompositeProduct.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
